import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-viewer-content__side" }
const _hoisted_2 = { class: "data-viewer-content__main" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  isDispMenu?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'data-viewer-content',
  props: {
    modifires: { type: [String, Array, Boolean] },
    isDispMenu: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _unref(mapModifires)('data-viewer-content', _ctx.modifires),
      _ctx.isDispMenu ? 'data-viewer-content-columns' : '',
    ])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "side")
    ], 512), [
      [_vShow, _ctx.isDispMenu]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "main")
    ])
  ], 2))
}
}

})